import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// Main components
import MainLayout from "../../../../components/main/layout/layout";
// Maintenance components
import MaintenanceView from "../../../../components/maintenance/view/view";
// Components
// import SettingsTabsMenu from "../../../../components/settings/tabsmenu/tabsmenu";
// Actions
import * as mainActions from "../../../../redux/actions/main";
import * as paramsActions from "../../../../redux/actions/params";
// Styles
import "./view.css";

const SettingsParamsView = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  // Selectors
  const currentPage = useSelector((state) => state.mainReducer.currentPage);

  // Set consts and vars
  const page = "settings";

  useEffect(() => {
    if (!!currentPage) return;
    // Set active page
    dispatch(mainActions.setCurrentPage(page));    
    // Set initial breadscrum
    const path = "settings_params";
    dispatch(mainActions.setBreadscrum(page, [{ path, pathKey: path, primaryValue: "", primaryName: "", }]));
  }, []);

  // Set grid config
  const filters = [`code`, `description`, `value`];
  const sorters = [`code`, `description`, `value`];
  const columns = [
    { 
      name: "code",
      width: `400px`,
      header: {
        dataType: "string",
        placeholder: "Codi",
        textAlign: "left",
      },
      style: {
        textAlign: "left",
        overflow: "hidden",         // Oculta el contenido que sobresale
        textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
        whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
      }
    },
    { 
      name: "description",
      header: {
        dataType: "string",
        placeholder: "Desc.",
        textAlign: "left",
      },
      style: {
        textAlign: "left",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },
    {
      name: "value",
      width: `200px`,
      header: {
        dataType: "string",
        placeholder: "Valor",
        textAlign: "center",
      },
      style: {
        textAlign: "center",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },
  ];

  return (
    <MainLayout isLoading={isLoading} setIsLoading={setIsLoading}>
      <div id="settings-params-view-content">
        {/* <div id="settings-params-view-tab-menu">
          <SettingsTabsMenu selectedTab="settings_params" />
        </div> */}
        <MaintenanceView 
          primaryKey={"code"}
          primaryNameKey={"description"}
          menuConfig={{
            buttonDetail: {
              visible: false,
            }
          }}
          gridConfig={{ 
            filters, 
            sorters, 
            columns,
            title: "Llista de <b>PARÀMETRES</b>",
            buttonDetailVisible: false,
          }}          
          reducerName="paramsReducer"
          itemNameSingular={"Paràmetre"}
          actions={paramsActions} 
          setIsLoading={setIsLoading}
          setRefreshData={setRefreshData}
          refreshData={refreshData}
          isMultiRowSelection={true}
          page={"settings_params"}
        />
      </div>
    </MainLayout>
  );
};

export default SettingsParamsView;
